class FeaturedProductsSlider extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('ul');
    if (!this.list) return;

    this.prevBtn = this.querySelector('[name="previous"]');
    this.nextBtn = this.querySelector('[name="next"]');
    this.dots = Array.from(this.querySelectorAll('.featured-products__dot'));
    this.slides = Array.from(this.list.children);

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.list.scrollBy({ left: -this.list.offsetWidth, behavior: 'smooth' });
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.list.scrollBy({ left: this.list.offsetWidth, behavior: 'smooth' });
      });
    }

    this.list.addEventListener('scroll', () => this.update(), { passive: true });

    const ro = new ResizeObserver(() => this.update());
    ro.observe(this.list);

    requestAnimationFrame(() => this.update());
  }

  update() {
    const { scrollLeft, scrollWidth, offsetWidth } = this.list;
    const hasOverflow = scrollWidth > offsetWidth + 5;

    if (this.prevBtn) this.prevBtn.disabled = scrollLeft < 5;
    if (this.nextBtn) this.nextBtn.disabled = !hasOverflow || scrollLeft >= scrollWidth - offsetWidth - 5;

    if (this.dots.length && this.slides.length) {
      const index = Math.round(scrollLeft / offsetWidth);
      const perSlide = this.slides.length;
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i % perSlide === index));
    }
  }
}

customElements.define('featured-products-slider', FeaturedProductsSlider);
